export default "__VITE_ASSET__CR1WOS6p__"